






























  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import { MessagingModule } from '@/store/modules/messaging';
import { AppModule } from '@/store/modules/app';
import AssignConversationRequest from '@/models/Conversations/AssignConversationRequest';
import EntityType from '@/models/Shared/EntityType';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';

@Component({
    name: 'AssignConversation'
})
export default class extends GiganautVueDialog {
 
    @Prop({required: true})
    entityType: EntityType;

    @Prop({required: true})
    agencyUsers: AgencyUserDto[];

    async assign(agencyUser: AgencyUserDto) {
        const request = new AssignConversationRequest();
        request.agencyUserId = agencyUser.id;
        if (this.entityType === EntityType.Worker) {
          WorkerDetailsModule.assignConversation(request);  
        } else {
          await MessagingModule.assignConversation(request);
        }
        
    }

    get agencyUsersFiltered() {
      if (this.entityType === EntityType.Worker) {
        if (WorkerDetailsModule.selectedConversation && WorkerDetailsModule.selectedConversation.assignedToEntityId) {
          return this.agencyUsers.filter((agencyUser) => (
          agencyUser.id !== WorkerDetailsModule.selectedConversation.assignedToEntityId
          ));
        } else {
          return this.agencyUsers;
        }
      } else {
        if (MessagingModule.selectedConversation && MessagingModule.selectedConversation.assignedToEntityId) {
          return this.agencyUsers.filter((agencyUser) => (
          agencyUser.id !== MessagingModule.selectedConversation.assignedToEntityId
          ));
        } else {
          return this.agencyUsers;
        }
      }
    }

    getUserAvatarUrl(user: AgencyUserDto) {
        return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/2/" + user.id + "/resized-100/" + user.avatar;
    }
}
